<template>
  <div class="container w-full h-full flex flex-wrap justify-center pb-12">
    <header class="text-center h3 w-full pb-8">{{ headerTxt }}</header>
    <div class="flex flex-wrap justify-between w-full lg:w-2/3">
      <div v-for="(block, index) in blocks" :key="index" class="accordion-container">
        <accordion-element v-for="element in block" :key="element.slug" :title="element.title" class="accordion-element mb-4">
          <ul>
            <template v-if="vragen">
              <li class="mb-2">
                <nuxt-link :to="{name: 'vragen-slug', params: {slug: element.slug}}" class="w-full h-full">
                  {{ element.excerpt }}
                </nuxt-link>
              </li>
            </template>

            <template v-if="handleiding">
              <li>
                <div class="prose" v-html="element.uitleg"/>
              </li>
            </template>
          </ul>
        </accordion-element>
      </div>
    </div>
  </div>
</template>

<script>
import AccordionElement from '~/components/base/AccordionElement';

export default {
  name: 'AccordionBlocks',
  components: {AccordionElement},
  props: {
    headerTxt: {
      type: String,
      default: 'Header',
    },
    title: {
      type: String,
      default: 'Titel',
    },
    vragen: {
      type: Boolean,
      default: false,
    },
    handleiding: {
      type: Boolean,
      default: false,
    },
    elements: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    blocks() {
      const indexToSplit = Math.ceil(this.elements.length / 2);

      return [this.elements.slice(0, indexToSplit), this.elements.slice(indexToSplit)];
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion-container {
  flex-flow: column wrap;
  flex-basis: 100%;
  @screen md {
    flex-basis: 49.4%;
  }
}
</style>
